import { all, call } from "redux-saga/effects";

import { userSagas } from "./user/user.sagas";
import { updatesSagas } from "./updates/updates.sagas";
import { instagramSagas } from "./instagram/instagram.sagas";
import { navSagas } from "./nav/nav.sagas";

export default function* rootSaga() {
  yield all([
    call(userSagas),
    call(updatesSagas),
    call(instagramSagas),
    call(navSagas),
  ]);
}
